export default function () {
  return {
    currentLottery: null
  }
}
